import React from 'react';
import styled from 'styled-components';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

import useMenuItems from '../../../hooks/use-menu-items';
import useActiveMenu from '../../../hooks/use-active-menu';

import Wrapper from './wrapper';
import NavItem from './nav-item';
import NavItemIcon from './nav-item-icon';
import NavLink from './nav-link';
import Children from './children';
import ChildItem from './child-item';
import ChildLink from './child-link';
import Button from './button';
import activeClassName from '../activeClassName';

const ListNav = ({
  className,
  setCoverOpen,
  navBreakpoint,
  pageId,
}) => {
  const { menuitems } = useMenuItems();
  // activeMenu is used to check if a page has active children and add active styling
  const activeMenu = useActiveMenu({ pageId, mustHaveSubpages: true });

  return (
    <nav className={className}>
      <Button
        navBreakpoint={navBreakpoint}
        onClick={() => setCoverOpen(true)}
      />
      <Wrapper navBreakpoint={navBreakpoint}>
        {menuitems.map(({
          id,
          page,
          subpage,
          externalpage,
        }) => {
          if (externalpage) {
            return (
              <NavItem key={id}>
                <NavLink as={OutboundLink} href={externalpage.externalLink}>
                  {externalpage.externalTitle}
                </NavLink>
              </NavItem>
            );
          }
          if (page) {
            return (
              <NavItem key={id}>
                <NavLink
                  activeClassName={activeClassName}
                  className={activeMenu?.page?.slug === page.slug ? activeClassName : ''}
                  to={page.slug}
                >
                  {page.title}
                  {subpage && subpage.length > 0 && (
                    <NavItemIcon />
                  )}
                </NavLink>
                {subpage && subpage.length > 0 && (
                  <Children>
                    {subpage.map((sub) => sub && (
                      <ChildItem key={sub.subpageId}>
                        <ChildLink
                          partiallyActive
                          activeClassName={sub.activeClassName}
                          to={sub.slug}
                        >
                          {sub.title}
                        </ChildLink>
                      </ChildItem>
                    ))}
                  </Children>
                )}
              </NavItem>
            );
          }
          return null;
        })}
      </Wrapper>
    </nav>
  );
};

export default styled(ListNav)``;
